'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpPricesComponent = require('rp-prices-component');

var _betslipInteracter = require('./betslipInteracter');

var _betslipInteracter2 = _interopRequireDefault(_betslipInteracter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initPrices() {
    new _rpPricesComponent.BestOdds();
    new _rpPricesComponent.BetHandler();
    _rpPricesComponent.priceButton.activate();
    var betslipInteracter = new _betslipInteracter2.default();
    betslipInteracter.init().then(function (betslipFeedName) {
        return _rpPricesComponent.pricesProvider.init(betslipFeedName);
    });
}

exports.default = initPrices;


//////////////////
// WEBPACK FOOTER
// ./public/js/initPrices.js
// module id = 628
// module chunks = 0